import Vue from 'vue'
import Modal from './Modal.vue'

Array.prototype.forEach.call(document.querySelectorAll('.has-modal'), (element) => {
    new Vue({
        el: element,
        components: {
            Modal,
        },
        data() {
            return {
                open: false,
            }
        },
        methods: {
            toggleModal(e) {                
                this.open = this.open ? false : true
                if(this.open) document.body.classList.add('modal-open')
                if(!this.open) document.body.classList.remove('modal-open')
            },
            cancelModal(e) {
                document.body.classList.remove('modal-open')
                return this.open = false
            },
            getQuery(param) {
                let query = window.location.search.substring(1)
                let vars = query.split("&")
                for (var i=0;i<vars.length;i++) {
                    let pair = vars[i].split("=")
                    if(pair[0] == param){ return pair[1] }
                }
                return(false)
            }
        },
        mounted() {
            
        }
    })
})


// WEBPACK FOOTER //
// ./assets/js/components/_modal.js